import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

const MKBox = React.lazy(() => import("components/MKBox"));
const MKTypography = React.lazy(() => import("components/MKTypography"));
const Information = React.lazy(() => import("pages/Des-spreNoi/sections/Information"));
const Team = React.lazy(() => import("pages/Des-spreNoi/sections/Team"));
const Newsletter = React.lazy(() => import("pages/Des-spreNoi/sections/Newsletter"));
const Logo = React.lazy(() => import("components/Logo"));

// Images
import despreNoi from "assets/images/Despre_Noi_mail.webp";

function DesSpreNoi() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Helmet>
                <title>Despre noi | Doral Cleaning – Servicii Profesionale de Curățenie</title>
                <link rel="canonical" href="https://doral-cleaning.ro/despre-noi-curatenie/" />
                <meta
                    name="description"
                    content="Află povestea Doral Cleaning. Cu o experiență de peste 20 de ani, oferim soluții de curățenie de înaltă calitate pentru clienți rezidențiali și comerciali."
                />
            </Helmet>
            <MKBox
                minHeight="75vh"
                width="100%"
                sx={{
                    backgroundImage: ({
                        functions: { linearGradient, rgba },
                        palette: { gradients },
                    }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.6),
                            rgba(gradients.dark.state, 0.6)
                        )}, url(${despreNoi})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            >
                <Container>
                    <Grid
                        container
                        item
                        xs={12}
                        lg={8}
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                        sx={{ mx: "auto", textAlign: "center" }}
                    >
                        <MKTypography
                            variant="h1"
                            color="white"
                            sx={({ breakpoints, typography: { size } }) => ({
                                [breakpoints.down("md")]: {
                                    fontSize: size["3xl"],
                                },
                            })}
                        >
                            Descoperă echipa DORAL CLEANING!
                        </MKTypography>
                        <MKBox display="flex" justifyContent="center" alignItems="center">
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href="#"
                                mr={3}
                            >
                                <i className="fab fa-facebook" />
                            </MKTypography>
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href="#"
                                mr={3}
                            >
                                <i className="fab fa-instagram" />
                            </MKTypography>
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href="#"
                                mr={3}
                            >
                                <i className="fab fa-twitter" />
                            </MKTypography>
                            <MKTypography component="a" variant="body1" color="white" href="#">
                                <i className="fab fa-google-plus" />
                            </MKTypography>
                        </MKBox>
                    </Grid>
                </Container>
            </MKBox>
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Information />
                <Team />
                <Logo />
                <Newsletter />
            </Card>
        </Suspense>
    );
}

export default DesSpreNoi;
